import { NgModule } from '@angular/core';
import { CommonModule, DatePipe, DecimalPipe, TitleCasePipe } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { DefaultPageComponent } from './components/default-page/default-page.component';
import { NgApexchartsModule } from 'ng-apexcharts';
import { McubeToLitrePipe } from './pipes/mcube-to-litre.pipe';
import { CountUpDirective } from './directives/count-up.directive';
import {TodayDateTimeDirective } from './directives/today-datetime.directive';
import { TimeFrameDirective } from './directives/time-frame.directive';
import { CalendarMaxTodayDirective } from './directives/calendar-max-today.directive';
import { ArrayManipulationService } from './services/array-manipulation.service';
import { BreadcrumbComponent } from './components/breadcrumb/breadcrumb.component';
import { Router, RouterModule } from '@angular/router';
import { NgxSpinnerModule } from 'ngx-spinner';
import { NgScrollbarModule } from 'ngx-scrollbar';
import { NgSelectModule } from '@ng-select/ng-select';
import { TableModule } from 'primeng/table';
import { DropdownModule } from 'primeng/dropdown';
import { CalendarModule } from 'primeng/calendar';
import { PaginatorModule } from 'primeng/paginator';
import { OverlayPanelModule } from 'primeng/overlaypanel';

import { ExportButtonComponent } from './components/buttons/export-button/export-button.component';
import { CustomDatatableComponent } from './components/custom-datatable/custom-datatable.component';
import { TimefromPipe } from './pipes/timeform.pipe';
import { NoSanitizePipe } from './pipes/no-sanitize.pipe';
import { TooltipModule } from 'primeng/tooltip';
import { ChipsModule } from 'primeng/chips';

import { NgbDropdownModule, NgbNavModule, NgbCarouselModule, NgbCollapse } from '@ng-bootstrap/ng-bootstrap';
import { ErrorHandlerService } from './services/error-handler.service';
import { ExportReportComponent } from './components/export-report/export-report.component';
import { ComparisonDatatableComponent } from './components/comparison-datatable/comparison-datatable.component';
import { ComparisonTableService } from 'src/app/services/comparison-table.service';
import { TimeFormatPipe } from './pipes/time-format.pipe';
import { ClipboardModule } from '@angular/cdk/clipboard';
import { OverlayEmptyDataComponent } from './components/overlay-empty-data/overlay-empty-data.component';
import { AlertPlaceholderComponent } from './components/alert-placeholder/alert-placeholder.component';
import { AccessDeniedOverlayComponent } from './components/access-denied-page/access-denied-page.component';
import { FullCalendarModule } from '@fullcalendar/angular';
import { ToggleButtonModule } from 'primeng/togglebutton';
import { MultiSelectModule } from 'primeng/multiselect';
import { TreeSelectModule } from 'primeng/treeselect';
import { ColorPickerModule } from 'primeng/colorpicker';
import { LabelDarkenColorPipe } from './pipes/label-darken-color.pipe';
import { LabelTextColorPipe } from './pipes/label-text-color.pipe';


@NgModule({
  declarations: [
    DefaultPageComponent,
    McubeToLitrePipe,
    CountUpDirective,
    TodayDateTimeDirective,
    TimeFrameDirective,
    CalendarMaxTodayDirective,
    BreadcrumbComponent,
    ExportButtonComponent,
    CustomDatatableComponent,
    TimefromPipe,
    NoSanitizePipe,
    ExportReportComponent,
    ComparisonDatatableComponent,
    TimeFormatPipe,
    LabelDarkenColorPipe,
    LabelTextColorPipe,
  ],
  imports: [
    CommonModule,
    RouterModule,
    NgSelectModule,
    TableModule,
    DropdownModule,
    CalendarModule,
    PaginatorModule,
    OverlayPanelModule,
    NgbDropdownModule,
    NgbCollapse,
    ClipboardModule,
    OverlayEmptyDataComponent,
    AlertPlaceholderComponent,
    AccessDeniedOverlayComponent,
    FullCalendarModule,
    MultiSelectModule,
    ToggleButtonModule,
    TreeSelectModule,
    ColorPickerModule
  ],
  exports:[
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    DefaultPageComponent,
    NgApexchartsModule,
    McubeToLitrePipe,
    CountUpDirective,
    TodayDateTimeDirective,
    TimeFrameDirective,
    CalendarMaxTodayDirective,
    NgxSpinnerModule,
    BreadcrumbComponent,
    NgScrollbarModule,
    NgSelectModule,
    OverlayEmptyDataComponent,
    AlertPlaceholderComponent,
    AccessDeniedOverlayComponent,

    TableModule,
    DropdownModule,
    CalendarModule,
    PaginatorModule,
    OverlayPanelModule,

    ExportButtonComponent,
    CustomDatatableComponent,
    ComparisonDatatableComponent,
    ExportReportComponent,
    TimefromPipe,
    NoSanitizePipe,
    TooltipModule,
    ChipsModule,
    TimeFormatPipe,
    LabelDarkenColorPipe,
    LabelTextColorPipe,

    NgbNavModule,
    NgbDropdownModule,
    NgbCarouselModule,
    NgbCollapse,
    FullCalendarModule,
    ToggleButtonModule,
    MultiSelectModule,
    TreeSelectModule,
    ColorPickerModule,
  ],
  providers:[
    DatePipe,
    FullCalendarModule,
    ArrayManipulationService,
    ErrorHandlerService,
    TitleCasePipe,
    ComparisonTableService,
    TimeFormatPipe,
    DecimalPipe,
  ]
})
export class SharedModule { }
